import { makeNiceName } from 'site-modules/shared/utils/nice-name';

export function normalizeContentVehicle(contentVehicle) {
  if (!contentVehicle?.make || !contentVehicle?.model) {
    return null;
  }

  return {
    make: makeNiceName(contentVehicle?.make),
    model: makeNiceName(contentVehicle?.model),
    year: contentVehicle?.year && parseInt(contentVehicle.year, 10),
  };
}
